/**
 * Created by Administrator on 2017/3/16.
 */
import { Component,OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { StroageService }     from '../service/stroage';

@Component({
  templateUrl:'./index.html'
})
export class Index implements OnInit{
  constructor(private stroage:StroageService,private route:Router){}
  private userName=this.stroage.getStroage('username');
  private name=this.stroage.getStroage('name');
  private roles:any=[];
  private logOut():void{
    this.stroage.clear();
    this.route.navigate(['/login']);
  }
  ngOnInit(){
    try{
      this.roles=this.stroage.getStroage('roles').split(',');

    }catch(e){
      this.route.navigate(['/login']);

    }
  }
  private show():void{
    document.getElementById("popup").style.display = "block";
  }
  private hide():void{
    document.getElementById("popup").style.display = "none";
  }
}



// WEBPACK FOOTER //
// /Users/ken/Dev/workspace/snowmantech/naturallyplus/web-cms/src/app/index/Index.component.ts